import { useGetUserAccountNumbers, UserType } from '@dhl/mdp-api'
import { UUID } from '~/common/model'
import { isBusinessUser } from '~/modules/users/model'

export const useUserAccountNumbers = (userType: UserType, userId: UUID) => {
  const disabled = !isBusinessUser(userType)
  const {
    data: userAccountNumberDtos,
    isFetching,
    refetch,
  } = useGetUserAccountNumbers(userId, {
    query: {
      enabled: !disabled,
    },
  })

  const userAccountNumbers: string[] = (userAccountNumberDtos || []).sort()
  return { userAccountNumbers, isLoading: isFetching, refetch }
}
